import * as React from "react";
import SplashGIF from "../../assets/node-zephyr.gif";
import { motion } from "framer-motion";
import "./SVGComponent.css";

const svgVariants = {
  hidden: {
    opacity: 0,
    rotate: -180,
  },
  visible: {
    opacity: 1,
    rotate: 0,
    transition: { duration: 1 },
  },
};

const pathVariants = {
  hidden: {
    opacity: 0,
    pathLength: 0,
  },
  visible: {
    opacity: 1,
    pathLength: 1,
    transition: {
      duration: 2,
      ease: "easeInOut",
    },
  },
};

const SvgComponent = (props) => {
  return (
    <div className="svg-container">
      {/* <motion.svg
        xmlns="http://www.w3.org/2000/svg"
        width={500}
        height={700}
        viewBox="0 0 723 1280"
        variants={svgVariants}
        fill="#ae67fa"
        initial="hidden"
        animate="visible"
        {...props}
      >
        <motion.path
          variants={pathVariants}
          d="M45 1.6C28.8 5.9 14.5 17.7 7.2 33-.7 49.5 0-11 0 640c0 650.7-.7 590.5 7.2 606.9 5.2 10.8 16.1 22.3 25.8 26.9 13.9 6.7-13.2 6.2 328.5 6.2s314.6.5 328.5-6.2c9.7-4.6 20.6-16.1 25.8-26.9 7.9-16.4 7.2 43.8 7.2-606.9 0-651 .7-590.5-7.2-607-5.2-10.9-16-22.1-25.8-26.8C676.1-.5 703.3 0 361 .1 93 .1 49.7.3 45 1.6zM682 614v490H41V124h641v490z"
        />
      </motion.svg> */}
      <motion.div
        variants={svgVariants}
        initial="hidden"
        animate="visible"
        className="svg-phone"
      >
        <img src={SplashGIF} />
      </motion.div>
    </div>
  );
};

export default SvgComponent;
